// base
import React, { Component } from 'react';

// components
import {
  Layout,
  Search,
  PageState,
  ContentsBox,
  TransactionsTable,
  AccountOverview,
  AccountTokenTransaction,
  Pager,
  IsLoadingLayout,
} from '../../components';
import ReactTooltip from 'react-tooltip';

import { Tab, Tabs, TabList, TabPanel } from 'react-tabs';
import "react-tabs/style/react-tabs.css";

// assets
import './account.scss';

import {
  accountDetail,
  transactionCntByAddress,
  transactionListByAddress,
  transferListByAccount
} from '../../../api';
import { connect } from "react-redux";

const types = [ '', 'send', 'recv' ];

class Account extends Component {

  constructor(props) {
    super(props);
    this.state = this.initState(props.network);
  };

  initState = (network) => {
    return {
      network: network,
      balance: 0,
      cnt: {
        totalCnt: 0,
        sendCnt: 0,
        recvCnt: 0
      },
      pageNum: 1,
      pages: 1,
      transactions: null,
      selectedTab: 0,
    }
  };

  getAccoutInfo = (address) => {
    accountDetail(this.state.network, address).then((res) => {
      if (res.data) {
        this.setState({ balance: res.data.balance });
      }
    }).catch((err) => {
      console.error(err);
    });
  };

  getTransactionCnt = (address) => {
    transactionCntByAddress(address).then((res) => {
      if (res.data) {
        this.setState({ cnt: res.data });
      }
    }).catch((err) => {
      console.error(err);
    });
  };

  getTransactionList = (address, pageNum=1, type=0) => {
    this.setState({ transactions: null });
    if (type === 3) {
      transferListByAccount(address, pageNum).then((res) => {
        if (res.data) {
          this.setState({
            transactions: res.data.list,
            pageNum: res.data.pageNum,
            pages: res.data.pages,
          });
        }
      }).catch((err) => {
        console.error(err);
      });
    } else {
      transactionListByAddress(address, pageNum, types[type]).then((res) => {
        if (res.data) {
          this.setState({
            transactions: res.data.list,
            pageNum: res.data.pageNum,
            pages: res.data.pages,
          });
        }
      }).catch((err) => {
        console.error(err);
      });
    }
  };

  loadPage = () => {
    const { address } = this.props.match.params;
    this.getAccoutInfo(address);
    this.getTransactionCnt(address);
    this.getTransactionList(address);
  };

  componentDidMount() {
    this.loadPage();
  };

  componentDidUpdate(prevProps) {
    const { address } = this.props.match.params;
    if (address !== prevProps.match.params.address) {
      this.setState(this.initState(this.state.network));
      this.loadPage();
    }
    ReactTooltip.rebuild();
  };

  getTransactionTable = () => {
    const { address } = this.props.match.params;
    const { transactions, pageNum, pages } = this.state;

    if (transactions == null) {
      return (
        <ContentsBox>
          <IsLoadingLayout isLoading={true} />
        </ContentsBox>
      );
    } else {
      return (
        <>
          <TransactionsTable address={address.toLowerCase()} transactions={transactions} />
          <div className="transactions_pager">
            <Pager currentPage={pageNum} totalnum={pages}
                   movepage={this.movePage} />
          </div>
        </>
      );
    }
  };

  getTokenTransactionTable = () => {
    const { address } = this.props.match.params;
    const { transactions, pageNum, pages } = this.state;

    if (transactions == null) {
      return (
        <ContentsBox>
          <IsLoadingLayout isLoading={true} />
        </ContentsBox>
      );
    } else {
      return (
        <>
          <AccountTokenTransaction address={address.toLowerCase()} transactions={transactions} />
          <div className="transactions_pager">
            <Pager currentPage={pageNum} totalnum={pages}
                   movepage={this.movePage} />
          </div>
        </>
      );
    }
  };

  movePage = (action) => {
    const { address } = this.props.match.params;
    const { pageNum, pages, selectedTab } = this.state;

    if (action === 'next' && pageNum < pages) {
      this.getTransactionList(address, pageNum + 1, selectedTab);
    } else if (action === 'prv' && pageNum > 1) {
      this.getTransactionList(address, pageNum - 1, selectedTab);
    }
  };

  changeTab = (index) => {
    const { address } = this.props.match.params;
    this.setState({ selectedTab: index });
    this.getTransactionList(address, 1, index);
  };

  render() {
    const { address } = this.props.match.params;
    const { balance, cnt, selectedTab } = this.state;

    return (
      <Layout>
        <main className="Account">
          <div className="l-wrapper">
            <div className="page_upper">
              <Search />
              <PageState pageName="Account" hash={address} />
            </div>
            <div className="account_contents_group">
              <div className="account_col">
                <ContentsBox title="Overview">
                  <AccountOverview address={address} balance={balance} cnt={cnt} />
                </ContentsBox>
              </div>
              <div className="account_col">
                <ContentsBox title="Transactions">
                  <Tabs selectedIndex={selectedTab} onSelect={this.changeTab}>
                    <TabList>
                      <Tab>Total</Tab>
                      <Tab>Send</Tab>
                      <Tab>Recv</Tab>
                      <Tab>Token Txs</Tab>
                    </TabList>
                    <TabPanel>{this.getTransactionTable()}</TabPanel>
                    <TabPanel>{this.getTransactionTable()}</TabPanel>
                    <TabPanel>{this.getTransactionTable()}</TabPanel>
                    <TabPanel>{this.getTokenTransactionTable()}</TabPanel>
                  </Tabs>
                </ContentsBox>
              </div>
              <ReactTooltip />
            </div>
          </div>
        </main>
      </Layout>
    )
  };
}

const mapStateToProps = (state) => {
  return {
    network: state.appState.network,
  };
};

const mapDispatchToProps = (dispatch) => ({});

export default connect(mapStateToProps, mapDispatchToProps)(Account);
